export const MINIMUM_INPUT_WIDTH = 11
export const BORDER_HORIZONTAL_WIDTH = 2
